// src/pages/BilisselBecerilerCreate.jsx
import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import Dropzone from "react-dropzone";
import { Editor } from "@tinymce/tinymce-react";
import { toast } from "react-toastify";

import useUserLanguage from "../../hooks/useUserLanguage";
import useTranslations from "../../hooks/useTranslations";

/* 6 editör alanı ve etiketleri */
const editorFields = [
  { name: "content_1", label: "İçerik" },
  { name: "content_2", label: "Puan 1 (0-20)" },
  { name: "content_3", label: "Puan 2 (21-40)" },
  { name: "content_4", label: "Puan 3 (41-60)" },
  { name: "content_5", label: "Puan 4 (61-80)" },
  { name: "content_6", label: "Puan 5 (81-100)" },
];

const BilisselBecerilerCreate = () => {
  /* ---------------- state ---------------- */
  const [form, setForm] = useState({
    title: "",
    cover: null,      // File
    gallery: null,    // File (tek resim)
    ...Object.fromEntries(editorFields.map(f => [f.name, ""]))
  });

  /* -------------- i18n helpers ----------- */
  const lang = useUserLanguage();
  const { translations } = useTranslations(lang);
  const t = (k, d = "") => translations[k] || d;

  const navigate = useNavigate();
  const update = (field, value) => setForm(prev => ({ ...prev, [field]: value }));
  const removeCover   = () => update("cover",   null);
const removeGallery = () => update("gallery", null);


  /* -------------- submit ----------------- */
const handleSubmit = async e => {
  e.preventDefault();
  const token = localStorage.getItem("admin_token");

  const fd = new FormData();
  fd.append("title", form.title);
  editorFields.forEach(f => fd.append(f.name, form[f.name] || ""));
  if (form.cover)   fd.append("cover", form.cover);
  if (form.gallery) fd.append("gallery", form.gallery);

  try {
    await axios.post(`${process.env.REACT_APP_API_BASE_URL}/api/skills/create`, fd, {
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "multipart/form-data",
      },
    });

    toast.success("Kayıt başarılı!");

    setTimeout(() => {
      navigate("/skills/table");
    }, 1500);

  } catch (err) {
    console.error("Skill ekleme hatası:", err);
    toast.error("Bir hata oluştu.");
  }
};

  /* -------------- tinyMCE --------------- */
 /* ---------- tinyMCE ---------- */
  const tinyInit = {
    promotion: false,
    height: 500,
    plugins: [
      "advlist", "autolink", "link", "image", "lists", "charmap",
      "preview", "anchor", "pagebreak", "searchreplace", "wordcount",
      "visualblocks", "code", "fullscreen", "insertdatetime", "media",
      "table", "emoticons", "help"
    ],
    toolbar:
      "undo redo | styles | bold italic | alignleft aligncenter alignright alignjustify | " +
      "bullist numlist outdent indent | link image | " +
      "print preview media fullscreen code | forecolor backcolor emoticons | help",
    content_style: "body { font-family:Helvetica,Arial,sans-serif; font-size:16px }",

    /* 🔽 MailTemplatesCreate ile aynı yaklaşım */
    automatic_uploads: true,
    images_upload_url: `${process.env.REACT_APP_API_BASE_URL}/api/skills/upload`,
    images_upload_handler: null,          // TinyMCE varsayılan XHR’i kullanır
    image_advtab: true,
  };

  /* -------------- JSX ------------------- */
  return (
    <form className="card p-4" onSubmit={handleSubmit}>
      {/* Başlık */}
      <div className="mb-3">
        <label className="form-label fw-bold">{t("TITLE")}</label>
        <input
          className="form-control"
          value={form.title}
          onChange={e => update("title", e.target.value)}
          required
        />
      </div>

     {/* Kapak görseli */}
<div className="mb-3">
  <label className="form-label fw-bold">{t("COVER")}</label>
  <Dropzone
    accept={{ "image/*": [] }}
    maxFiles={1}
    
    onDrop={files => update("cover", files[0])}
  >
    {({ getRootProps, getInputProps }) => (
      <section {...getRootProps()} className="border border-dashed p-4 text-center rounded">
        <input {...getInputProps()} />
        {form.cover instanceof File ? (
          <div>
            <img
              src={URL.createObjectURL(form.cover)}
              alt="Kapak"
              style={{ maxHeight: 120 }}
              className="img-thumbnail mb-2"
            />
            <div className="d-flex justify-content-between align-items-center">
              <p className="small m-0">{form.cover.name}</p>
              {/* Sil butonu */}
              <button
                type="button"
                className="btn btn-sm btn-outline-danger"
                
                onClick={(e) => {
                  e.stopPropagation();   // 🔑 dialog açılmasını engeller
                  removeCover();
                }}
                
              >
                ×
              </button>
            </div>
          </div>
        ) : (
          <p>{t("DRAG_DROP")}</p>
        )}
      </section>
    )}
  </Dropzone>
</div>

{/* Galeri görseli */}
<div className="mb-3">
  <label className="form-label fw-bold">{t("GALLERY")}</label>
  <Dropzone
    accept={{ "image/*": [] }}
    maxFiles={1}
    onDrop={files => update("gallery", files[0])}
  >
    {({ getRootProps, getInputProps }) => (
      <section {...getRootProps()} className="border border-dashed p-4 text-center rounded">
        <input {...getInputProps()} />
        {form.gallery instanceof File ? (
          <div>
            <img
              src={URL.createObjectURL(form.gallery)}
              alt="Galeri"
              style={{ maxHeight: 120 }}
              className="img-thumbnail mb-2"
            />
            <div className="d-flex justify-content-between align-items-center">
              <p className="small m-0">{form.gallery.name}</p>
              {/* Sil butonu */}
              <button
                type="button"
                className="btn btn-sm btn-outline-danger"
                onClick={(e) => {
                  e.stopPropagation(); 
                  removeGallery();
                }}
              >
                ×
              </button>
            </div>
          </div>
        ) : (
          <p>{t("DRAG_DROP")}</p>
        )}
      </section>
    )}
  </Dropzone>
</div>

      {/* Editörler */}
      {editorFields.map(({name,label}) => (
        <div className="mb-4" key={name}>
          <label className="form-label fw-bold">{label}</label>
          <Editor
            tinymceScriptSrc="https://cdnjs.cloudflare.com/ajax/libs/tinymce/7.6.1/tinymce.min.js"
            value={form[name]}
            onEditorChange={c => update(name,c)}
            init={tinyInit}
          />
        </div>
      ))}

    <div className="d-flex justify-content-center">
      <button className="btn btn-primary" type="submit">
        {t("SAVE")}
      </button>
      </div>

      
    </form>
  );
};

export default BilisselBecerilerCreate;
